import { Company } from '@/types'

export function isChangingAccountantWithoutCertificate(
  company: Pick<Company, 'status' | 'certificates'>,
) {
  return (
    company.status === 'changing_accountant' && !company.certificates?.length
  )
}
